/**
 * Resolve a slide/layer id to the catalogue model name (path for GLBs, Name for DB layers).
 */
export function resolveLayerKey(modelList, id) {
  if (!id) return null;
  const needle = String(id);

  for (const section of modelList || []) {
    for (const m of section.models || []) {
      if (m.name === needle) return m.name;
      if (m.displayName === needle) return m.name;
      if (m.path === needle) return m.name;
      const base = String(m.name || '')
        .split('/')
        .pop()
        ?.replace(/\.(glb|zip)$/i, '');
      if (base === needle) return m.name;
      const urlBase = String(m.url || '')
        .split('?')[0]
        .split('/')
        .pop()
        ?.replace(/\.(glb|zip)$/i, '');
      if (urlBase === needle) return m.name;
    }
  }
  return needle;
}

export function modelFileChanged(oldLayer, model) {
  if (!oldLayer || !model) return false;
  if (oldLayer.url && model.url && oldLayer.url !== model.url) return true;
  if (oldLayer.mtime != null && model.mtime != null && Number(oldLayer.mtime) !== Number(model.mtime)) return true;
  if (oldLayer.size != null && model.size != null && Number(oldLayer.size) !== Number(model.size)) return true;
  return false;
}

export function modelCacheUrls(model) {
  return [model?.url, model?.hole_url, model?.assay_url, model?.coll_url, model?.geology_url].filter(Boolean);
}

export function collectPrecacheUrls(modelList) {
  const urls = [];
  (modelList || []).forEach((section) => {
    (section.models || []).forEach((m) => {
      urls.push(...modelCacheUrls(m));
    });
  });
  return [...new Set(urls)];
}
